import {Record} from 'immutable';
import {ReduceStore} from 'flux/utils';
import ActionTypes from '../ActionTypes';
import AppDispatcher from '../AppDispatcher';
import LandPageTypes from '../views/LandPageTypes';
import AdminPageTypes from '../views/AdminPageTypes';

const State = new Record({
    landPage: null,
    adminPage: null,
});

class AppStore extends ReduceStore {
    constructor() {
        super(AppDispatcher);
    }

    getInitialState() {
        return new State();
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.START:
                if (!action.token && !action.landPage) return state;
                return state.set('landPage', action.landPage);

            case ActionTypes.LOGIN_FINISH:
                return state.set('landPage', LandPageTypes.ADMIN);

            case ActionTypes.LOGOUT:
            case ActionTypes.UPDATE_TOKEN_FAILED:
                return state
                    .set('landPage', LandPageTypes.LOGIN)
                    .set('adminPage', null);

            case ActionTypes.CONFIGURE_LOTTERY:
                return state.set('landPage', LandPageTypes.LOTTERY);

            case ActionTypes.CLOSE_LOTTERY:
                return state.set('landPage', LandPageTypes.ADMIN);

            case ActionTypes.CHOOSE_MENU_START:
                return state.set('adminPage', AdminPageTypes.LOADING);

            case ActionTypes.CHOOSE_MENU_FINISH:
                return state.set('adminPage', action.menu);

            default:
                return state;
        }
    }
}

export default new AppStore();



// WEBPACK FOOTER //
// src/stores/AppStore.js